import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import noop from 'lodash/noop';

import themeable from 'zignal-landscape/lib/themeable';
import Button from 'zignal-landscape/lib/Button';

const DropdownItem = ({
  styles,
  buttonText,
  icon,
  isUnread = false,
  label,
  subtitle,
  timestamp,
  title,
  url,
  isNewNav = false,
  navigate = noop
}) => {
  const cx = classNames.bind(styles);
  const dropdownItemClasses = cx({
    dropdownItem: true,
    dropdownItemNewNav: isNewNav,
    unread: isUnread
  });

  function onButtonClick() {
    window.open(url);
  }
  const Icon = icon;

  let listItemContents = (
    <div className={styles.wrapper}>
      <div className={styles.iconWrapper}>
        <Icon />
      </div>

      <div className={styles.mainBody}>
        <p className={styles.label}>
          {label}
        </p>

        <p className={styles.titlesWrapper}>
          <span className={styles.mainTitle}>{title}</span>
    &nbsp;
          <span className={styles.subtitle}>{subtitle}</span>
        </p>

        {(buttonText === undefined || url === undefined) ? null : (
          <div className={styles.buttonWrapper}>
            <Button
              buttonStyle="secondary"
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>

      <div className={styles.timestamp}>
        {timestamp}
      </div>
    </div>
  );

  // Conditionally make the DropdownItem a clickable link (support tabbed browsing)
  if(buttonText === undefined && url !== undefined) {
    listItemContents = (
      <a className={styles.link} href={url} onClick={navigate}>
        {listItemContents}
      </a>
    );
  }

  return (
    <li className={dropdownItemClasses}>
      {listItemContents}
    </li>
  );
};

DropdownItem.propTypes = {
  styles: PropTypes.object,
  buttonText: PropTypes.string,
  icon: PropTypes.any.isRequired,
  isUnread: PropTypes.bool,
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  isNewNav: PropTypes.bool,
  navigate: PropTypes.func
};

DropdownItem.displayName = 'DropdownItem';

export default themeable(DropdownItem);
